import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLORS } from 'theme';
import Tag from '..';

const STYLE_VARIANTS = {
  red: {
    root: `
      background: ${COLORS.red};
    `,
    label: `
      color: ${COLORS.white};
    `,
  },
  blue: {
    root: `
      background: ${COLORS.kinetikBlue};
    `,
    label: `
      color: ${COLORS.white};
    `,
  },
  gray: {
    root: `
      background: ${COLORS.black10};

      :hover {
        background: ${COLORS.black30};
      }
    `,
    label: `
      color: ${COLORS.black90};
    `,
  },
  white: {
    root: `
      background-color: ${COLORS.white};
    `,
    label: `
      color: ${COLORS.kinetikBlack}
    `,
  },
};

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    border: none;
    height: 20px;

    ${({ $variant }) => STYLE_VARIANTS[$variant].root}
  }

  && .MuiChip-label {
    padding: ${({ theme }) => `${theme.spacing.s1} ${theme.spacing.s2}`};
    font-size: ${({ theme }) => theme.fontSize.h6};
    line-height: ${({ theme }) => theme.lineHeight.h6};
    font-weight: ${({ theme }) => theme.fontWeight.medium};

    ${({ $variant }) => STYLE_VARIANTS[$variant].label}
  }
`;

const AmountTag = ({ amount, variant, ...props }) => (
  <StyledTag label={amount?.toLocaleString()} $variant={variant} {...props} />
);

AmountTag.propTypes = {
  amount: PropTypes.number,
  variant: PropTypes.oneOf(Object.keys(STYLE_VARIANTS)),
};

export default memo(AmountTag);
